import React from "react";
import { useTranslation } from "react-i18next";
import { PageHero } from "./About";
import { Megaphone, Users, TrendingUp, Wrench, GraduationCap, ShieldCheck, LineChart, Truck, Briefcase } from "lucide-react";

const ICON_MAP = { marketing: Megaphone, dealer: Users, sales: TrendingUp, aftersales: Wrench, training: GraduationCap, compliance: ShieldCheck, crm: LineChart, logistics: Truck, bd: Briefcase };

export default function Services() {
  const { t } = useTranslation();
  const sections = t("services_page.sections", { returnObjects: true });
  const keys = Object.keys(sections);
  return (
    <div data-testid="page-services">
      <PageHero eyebrow="Services" title={t("services_page.hero_title")} subtitle={t("services_page.hero_subtitle")} image="https://images.pexels.com/photos/19233057/pexels-photo-19233057.jpeg"/>
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {keys.map((k, i) => {
            const Icon = ICON_MAP[k] || Briefcase;
            const s = sections[k];
            return (
              <div key={k} data-testid={`service-detail-${k}`} className="premium-card p-8">
                <div className="h-12 w-12 rounded-sm bg-[#003399]/5 flex items-center justify-center mb-6"><Icon className="text-[#003399]" strokeWidth={1.5}/></div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-slate-400 font-display">Service {String(i+1).padStart(2,'0')}</div>
                <h3 className="mt-2 font-display font-semibold text-xl text-[#0B1120]">{s.title}</h3>
                <p className="mt-3 text-sm text-[#4A5568] leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
